import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { Overline, Reveal } from "./Reveal";

export const ComingSoon = () => {
  const { t } = useLang();
  const cs = t.comingSoon;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const y = useTransform(scrollYProgress, [0, 1], [160, 0]);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0.35, 1]);

  return (
    <section
      id="app"
      ref={ref}
      className="relative bg-nero-black text-white overflow-hidden border-b border-white/10"
      data-testid="coming-soon"
    >
      <div className="absolute inset-0 grain opacity-[0.05] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Text */}
          <div>
            <Reveal>
              <Overline index="08" dark>{cs.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-[3.5rem] font-medium tracking-tight leading-[1.04]">
                {cs.title}
              </h2>
            </Reveal>
          </div>

          {/* Phone mockup — slides in on scroll */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[340px] w-[340px] rounded-full bg-nero-green/20 blur-[130px] pointer-events-none" />
            <motion.img
              src="/app-mockup.png"
              alt="NeroChar App – Biochar Marktpreise"
              style={{ y, opacity }}
              className="relative w-[280px] sm:w-[380px] lg:w-[460px] h-auto"
              data-testid="app-mockup"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
